{
	"title": "Σχόλια",
	"statuses": {
		"inValidation": "Στην επικύρωση",
		"rejected": "Απορρίφθηκε",
		"assured": "Διασφαλισμένο",
		"flagged": "Επισημασμένο",
		"resolved": "Επιλύθηκε"
	}
}
